// src/services/emailService.js
import emailjs from 'emailjs-com';

// Get credentials from environment variables
const EMAILJS_PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY;
const EMAILJS_SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID;
const EMAILJS_TEMPLATE_ID = import.meta.env.VITE_EMAILJS_TEMPLATE_ID;

// Use a valid email address for testing
// Change this to a real email that exists
const RECIPIENT_EMAIL = 'your-personal-email@gmail.com'; // Change this!

export const sendEmail = async (formData) => {
  try {
    // Get current time
    const now = new Date();
    const timeString = now.toLocaleString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });

    // Prepare the template parameters
    const templateParams = {
      to_email: RECIPIENT_EMAIL, // Use the valid email
      from_name: formData.name,
      from_email: formData.email || 'no-reply@nexcom.ke',
      phone: formData.phone,
      message: formData.message,
      name: formData.name,
      time: timeString,
      subject: `New Inquiry from ${formData.name}`,
    };

    console.log('Sending email with params:', templateParams);

    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams,
      EMAILJS_PUBLIC_KEY
    );

    console.log('Email sent successfully:', response);
    return { success: true, data: response };
  } catch (error) {
    console.error('Email sending failed:', error);
    console.error('Error details:', error.text);
    return { 
      success: false, 
      error: error.text || 'Failed to send email. Please try again.' 
    };
  }
};